import React, { useState, useEffect, memo } from 'react'
import 'cherry-markdown/dist/cherry-markdown.css'
// import Cherry from 'cherry-markdown';
import Cherry from 'cherry-markdown/dist/cherry-markdown.core'
import { v4 as uuid } from 'uuid'

interface MarkdownItemProps {
  content: string
  id: string
}

const MarkdownItem = memo(({ content, id }: MarkdownItemProps) => {
  const [cherryInstance, setCherryInstance] = useState<null|Cherry>(null)
  useEffect(() => {
    setCherryInstance(new Cherry({
      id: `cherry-markdown-${id}`,
      value: content,
      editor: {
        height: 'auto',
        defaultModel: 'previewOnly',
      },
      toolbars: {
        showToolbar: false,
      },
      engine: {
        global: {
          flowSessionContext: true,
          flowSessionCursor: 'default',
        },
      },
      previewer: {
        enablePreviewerBubble: false,
      },
      isPreviewOnly: true,
      autoScrollByCursor: true,

    }))
    return () => {
      // eslint-disable-next-line no-unused-expressions
      cherryInstance?.destroy()
    }
  }, [])
  useEffect(() => {
    if (cherryInstance) {
      cherryInstance.setMarkdown(content)
    }
  }, [cherryInstance, content])
  return (
    <div style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: '16px' }}>
      <div className="script-markdown" id={`cherry-markdown-${id}`} />
    </div>
  )
})

export default MarkdownItem
